<template>
  <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.1214 1.877H3.05477V0.699219H11.2992V8.94366H10.1214V1.877ZM4.23255 6.58811V5.41033H5.41033V6.58811H6.58811V7.76589H5.41033V8.94366H4.23255V7.76589H3.05477V6.58811H4.23255Z" fill="currentColor" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.699219 3.05477H8.94366V11.2992H0.699219V3.05477ZM1.877 4.23255H7.76589V10.1214H1.877V4.23255Z" fill="currentColor" />
  </svg>
</template>
